export default {
  SET_USER: 'SET_USER',
  SET_LOADING: 'SET_LOADING',
};
